import { CurrencyType } from '../web3';

type NormalizedRoomData = {
  room: {
    roomId: number;
    playerA: { address: `0x${string}`; wins: bigint };
    playerB: { address: `0x${string}`; wins: bigint };
    bet: number;
    token: `0x${string}`;
    roomStatus: number;
    winsTo: number;
    roundCounter: number;
    closer: number;
    deadline: bigint;
    winnerStatus: number;
  };
  rounds: {
    playerA: { move: number; encrMove: `0x${string}` };
    playerB: { move: number; encrMove: `0x${string}` };
    winner: number;
    stage: number;
    roundStage: number;
  }[];
  wins: {
    winsPlayerA: number;
    winsPlayerB: number;
  };
  streamCurrency: CurrencyType;
  currentRound: number;
  roomDescription: string;
};

export type MappedRounds = {
  moveA: number;
  moveB: number;
  encrMoveA: `0x${string}`;
  encrMoveB: `0x${string}`;
  winner: number;
  stage: number;
  roundStage: number;
}[];

export const normalizeRoomData = (data: any): NormalizedRoomData => {
  return {
    room: {
      roomId: Number(data.room.roomId),
      playerA: {
        address: data.room.playerA.address,
        wins: BigInt(data.room.playerA.wins),
      },
      playerB: {
        address: data.room.playerB.address,
        wins: BigInt(data.room.playerB.wins),
      },
      bet: Number(data.room.bet),
      token: data.room.token,
      roomStatus: Number(data.room.roomStatus),
      winsTo: Number(data.room.winsTo),
      roundCounter: Number(data.room.roundCounter),
      closer: Number(data.room.closer),
      deadline: BigInt(data.room.deadline),
      winnerStatus: Number(data.room.winnerStatus),
    },
    rounds: data.rounds.map((r: any) => ({
      playerA: {
        move: Number(r.playerA.move),
        encrMove: r.playerA.encrMove,
      },
      playerB: {
        move: Number(r.playerB.move),
        encrMove: r.playerB.encrMove,
      },
      winner: Number(r.winner),
      stage: Number(r.stage),
      roundStage: Number(r.roundStage),
    })),
    wins: {
      winsPlayerA: Number(data.wins.winsPlayerA),
      winsPlayerB: Number(data.wins.winsPlayerB),
    },
    streamCurrency: {
      chainId: Number(data.streamCurrency.chainId),
      address: data.streamCurrency.address as `0x${string}`,
      symbol: String(data.streamCurrency.symbol),
      decimals: Number(data.streamCurrency.decimals),
      bet: data.streamCurrency.bet.map((bet: number) => String(bet)),
      minBet: Number(data.streamCurrency.minBet),
    },
    currentRound: Number(data.currentRound),
    roomDescription: data.roomDesctiption,
  };
};

export const normalizeRounds = (data: any): MappedRounds => {
  return data?.rounds?.map((round) => ({
    encrMoveA: round.playerA.encrMove,
    encrMoveB: round.playerB.encrMove,
    moveA: Number(round.playerA.move),
    moveB: Number(round.playerB.move),
    roundStage: Number(round.roundStage),
    stage: Number(round.stage),
    winner: Number(round.winner),
  }));
};
